import Swal from "sweetalert2";
import UseToggle from "../../../Hooks/UseToggle";
import { Button, Card, Col, Container, Form, Row, Badge } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { ListLoader } from "../../../Hooks/PageLoader";
import { GoArrowSwitch, GoGear } from "react-icons/go";
import { GrOrganization } from "react-icons/gr";
import { accountServices } from "../../../APIServices/PasswordManagement/accountServices";
import { useEffect, useState } from "react";
import { userServices } from "../../../APIServices/UserData/userServices";
import { handleResponse } from "../../../APIHelpers/Responses";
import CreateNewAccount from "./ModalCanvasPage/CreateNewAccount";
import UpdateAccount from "./ModalCanvasPage/UpdateAccount";
import PermanentDeleteAccount from "./ModalCanvasPage/PermanentDeleteAccount";

const ManageAnotherAccount = ({ auth, isDark, organizationList, currentUserData, setUpdator }) => {
  const toggles = UseToggle();
  const [adminId, setAdminId] = useState("");
  const [accountData, setAccountData] = useState("");
  const [accountList, setAccountList] = useState([]);
  const [accountListLoader, setAccountListLoader] = useState(false);
  const [password, setPassword] = useState("");

  const getAccountList = async () => {
    setAccountListLoader(true)
    let data = await accountServices.getAccountList(auth, adminId, "list")
    setAccountList(data?.data || [])
    setAccountListLoader(false)
  }

  const deleteAccount = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to permanent delete account?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.accountId = accountData?.accountId;
        let data = await accountServices.deleteAccount(auth, userData);
        if (data?.statusCode === 200) {
          getAccountList();
        }
      }
    });
  };

  const switchLoginAccount = async (item) => {
    if (item?.status === "active") {
      if (item?.loginStatus) {
        await handleResponse({
          statusCode: 400,
          customMessage: "Opps! You have already logged In.",
        })
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to login in this account?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, login it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            let userData = {};
            userData.loginAccountId = item?.accountId;
            let data = await userServices.switchLoginAccount(auth, userData);
            if (data?.statusCode === 200) {
              getAccountList();
              setUpdator(`allUpdate_${Math.floor(10000 + Math.random() * 90000)}`);
            }
          }
        });
      }
    } else {
      await handleResponse({
        statusCode: 400,
        customMessage: "Access denied. This account is currently disabled.",
      })
    }
  };

  const switchToPersonalAccount = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to switch to account?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, switch it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.loginAccountId = "";
        let data = await userServices.switchLoginAccount(auth, userData);
        if (data?.statusCode === 200) {
          getAccountList();
          setUpdator(`allUpdate_${Math.floor(10000 + Math.random() * 90000)}`);
        }
      }
    });
  };

  useEffect(() => {
    if (adminId) {
      getAccountList()
    }
  }, [auth, adminId]);

  useEffect(() => {
    if (currentUserData?.roleType === "organization") {
      setAdminId(currentUserData?.userId)
    } else {
      if (organizationList?.length === 1) {
        setAdminId(organizationList?.[0]?.adminId)
      }
    }
  }, [currentUserData]);

  return (
    <>
      <div className={`pb-1 pt-3 px-3 ${organizationList?.length === 1 && "w-75 m-auto"}`}>
        <h5 className="fw-bold mb-1">Manage Another Account</h5>
      </div>
      <div className={`p-3 overflow-auto ${organizationList?.length === 1 && "w-75 m-auto"}`} style={{ height: "calc(100vh - 48px)" }}>
        <Card className="border rounded">
          <Card.Body className="p-0">
            <div className="d-flex justify-content-between pt-3 px-3">
              <div>
                <h6 className="fw-bold mb-0">Account</h6>
                <p className="small text-muted">Account store all of your passwords, credit cards, and other items.</p>
              </div>
              {currentUserData?.roleType === "organization" ?
                <Button className="text-nowrap hstack gap-2 btn-gradient h-100" style={{ fontSize: 13 }} title="Add New Account" onClick={() => toggles?.setToggle()}><FaPlus /> New Account</Button>
                : currentUserData?.loginAccountId &&
                <Button className="text-nowrap hstack gap-2 btn-gradient h-100" style={{ fontSize: 13 }} title="Switch to Personal" onClick={switchToPersonalAccount}><GoArrowSwitch /> Switch to Personal</Button>
              }
            </div>
            <div className="overflow-hidden" style={{ maxHeight: "calc(100vh - 154px)" }}>
              <Container fluid>
                <Row className="pt-1">
                  {adminId ? (
                    <Form.Group as={Col} md={adminId ? 3 : 12} className="py-2 overflow-auto" style={{ maxHeight: "calc(100vh - 165px)" }}>
                      {currentUserData?.roleType === "individual" && organizationList?.length > 1 &&
                        <div className="item-list">
                          {organizationList?.map((item, index) => {
                            const isActive = adminId === item?.adminId;
                            return (
                              <div
                                key={index}
                                className={`member-card border ${isActive ? item?.status === "inactive" ? "border-danger bg-danger-subtle" : "border-success bg-success-subtle" : ""}`}
                                onClick={() => setAdminId(item?.adminId)}
                                role="button"
                              >
                                <div className="member-info">
                                  <div className="member-name">
                                    <div><GrOrganization /></div>
                                    <div style={{ fontSize: 13 }}>{item?.name}</div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      }
                    </Form.Group>
                  ) : (currentUserData?.roleType === "individual" && organizationList?.length > 1 &&
                    <div className="item-list" style={{ flexDirection: "row" }}>
                      {organizationList?.map((item, index) => {
                        const isActive = adminId === item?.adminId;
                        return (
                          <div
                            key={index}
                            className={`member-card border ${isActive ? item?.status === "inactive" ? "border-danger bg-danger-subtle" : "border-success bg-success-subtle" : ""}`}
                            onClick={() => setAdminId(item?.adminId)}
                            style={{ minWidth: 185 }}
                            role="button"
                          >
                            <div className="member-info">
                              <div className="member-name">
                                <GrOrganization style={{ width: 20 }} /> {item?.name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <Form.Group as={Col} md={organizationList?.length === 1 ? 12 : 9} className="py-2 overflow-auto" style={{ maxHeight: "calc(100vh - 165px)" }}>
                    {accountListLoader ? (
                      <ListLoader />
                    ) : (
                      <Row>
                        {accountList?.map((item, index) => (
                          <Form.Group key={index} as={Col} md={6} className="mb-2">
                            <button title={item?.name} className={`category-card w-100 d-block align-items-start overflow-hidden text-start p-0 ${isDark ? "dark" : ""}`}>
                              <div onClick={() => switchLoginAccount(item)} style={{ fontSize: 14 }} className={`border-bottom py-2 px-3  ${isDark ? "bg-dark" : "bg-light"}`}>
                                <div className="hstack justify-content-between">
                                  <div className="fw-bold m-0">{item?.name}</div>
                                  <div className="hstack gap-2">
                                    {item?.category === "primary" ?
                                      <>
                                        {currentUserData?.roleType === "organization" &&
                                          <Badge bg="primary" className="rounded-1 text-capitalize">{item?.category}</Badge>
                                        }
                                      </>
                                      : item?.status === "inactive" &&
                                      <Badge bg="outline-secondary" style={{ cursor: "no-drop" }} className="rounded-1 text-muted text-capitalize">Disabled</Badge>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div onClick={() => switchLoginAccount(item)} style={{ fontSize: 13, height: 180 }} className="py-2 px-3 text-muted overflow-auto">
                                <p className="mb-1">{item?.totalPersonalItem}</p>
                                <p className="mb-1">{item?.totalItem}</p>
                                <p className="mb-1">{item?.totalGroup}</p>
                                <p className="mb-2">{item?.totalMember}</p>
                                <p>{item?.description}</p>
                              </div>
                              <div style={{ fontSize: 14 }} className={`border-top py-2 px-3 hstack ${(currentUserData?.roleType === "organization" ? "justify-content-between" : (item?.loginStatus ? "justify-content-between" : "justify-content-end"))}`}>
                                {currentUserData?.roleType === "organization" &&
                                  <GoGear title="Update Account" onClick={(e) => { setAccountData(item); e.stopPropagation(); toggles.setToggle1() }} />
                                }
                                {item?.status === "active" &&
                                  <>
                                    {item?.loginStatus ?
                                      <span className="text-success text-center fw-bold" style={{ fontSize: 12 }}>Currently logged in to this account.</span>
                                      :
                                      <Badge bg="success" onClick={() => switchLoginAccount(item)} className="rounded-1 text-capitalize">Login</Badge>
                                    }
                                  </>
                                }
                              </div>
                            </button>
                          </Form.Group>
                        ))}
                      </Row>
                    )}
                  </Form.Group>
                </Row>
              </Container>
            </div>
          </Card.Body>
        </Card>
      </div>
      <CreateNewAccount
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        isDark={isDark}
        Title={`Add New Account`}
        getAccountList={getAccountList}
        setUpdator={setUpdator}
        auth={auth}
      />
      <UpdateAccount
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        PermanentDeleteAccount={toggles.setToggle2}
        isDark={isDark}
        Title={`Update Account`}
        getAccountList={getAccountList}
        accountData={accountData}
        auth={auth}
        setUpdator={setUpdator}
      />
      <PermanentDeleteAccount
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        setPassword={setPassword}
        password={password}
        deletePermanentAccount={deleteAccount}
        Title="Permanent Delete Account"
        isDark={isDark}
        setUpdator={setUpdator}
        auth={auth}
      />
    </>
  );
};

export default ManageAnotherAccount;
